import { render, staticRenderFns } from "./FDinCarouselTable.vue?vue&type=template&id=6fa6f0d1&scoped=true"
import script from "./FDinCarouselTable.vue?vue&type=script&lang=js"
export * from "./FDinCarouselTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa6f0d1",
  null
  
)

export default component.exports